import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@cronika/ui";
import { useTranslation } from "@cronika/locales";
import { FC } from "react";
import { userStore } from "@/shared/stores/UserStore";

type TSignOutModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm?: () => void | Promise<void>;
};

export const SignOutModal: FC<TSignOutModalProps> = ({ open, setOpen, onConfirm }) => {
  const { t } = useTranslation("layout");

  const handleSignOut = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      userStore.logoutAsync();
    }
    setOpen(false);
  };

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <ModalContent
        size="md"
        backdrop="transparent"
        overlayClassName="bg-black/30"
        className="z-[101] border backdrop-blur-xl border-white/10 shadow-2xl"
        style={{ backgroundColor: "rgba(20, 20, 20, 0.2)" }}
      >
        <ModalHeader className="flex flex-col items-center gap-1 border-b border-white/10 text-center font-semibold">
          {t("logout.title")}
        </ModalHeader>
        <ModalBody className="p-5 flex flex-col items-center">
          <p className="text-base text-[#8C8C8C] text-center">{t("logout.message")}</p>
        </ModalBody>
        <ModalFooter>
          <div className="flex justify-center gap-3 w-full">
            <Button variant="bordered" onClick={() => setOpen(false)} className="w-full">
              {t("logout.cancel-btn")}
            </Button>
            <Button onClick={handleSignOut} variant="solid" className="bg-[#F31260] w-full">
              {t("logout.confirm-btn")}
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
